export const LOCALES ={
    ENGLISH: 'en-us',
    ITALIAN : 'it',
    ALBANIAN : 'al'
}